import {createContext} from 'react'

export const OrderAuditContext = createContext({
  hasWritePermission: false,
  tabView: '',
  orderAuditList: [] as any,
  isLoading: false,
  filters: {} as any,
  onSearch: (searchValue: string) => {},
  onSortingChange: (sortBy: string, sortOrder: string) => {},
  salesReps: [] as any,
  isSalesRepDropdownLoading: false,
  onChangeSalesRepFilter: (selectedOption: any) => {},
  onUpdateStatus: (orderId: number | string, payload: any) => {},
  isOperationLoading: false,
})
